import React from "react";

import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { MedicalDevice } from "@/models/DeviceModel";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { DateUtils } from "@/utils/dateUtils";

export type LastDeviceUploadProps = {
  devices: MedicalDevice[];
};

export const LastDeviceUpload: React.FC<LastDeviceUploadProps> = ({ devices }) => {
  const { t } = useTranslation();
  const latestDevice = (devices ?? []).toSorted((a, b) => DateUtils.compareDateTimes(b.lastUpload, a.lastUpload));
  return (
    <div>
      <Typography variant="body">
        {`${t("devices.lastUpload")}: ${
          latestDevice.length > 0 && latestDevice[0].lastUpload
            ? DateTime.fromISO(latestDevice[0].lastUpload).toLocaleString(DateTime.DATETIME_MED)
            : t("devices.neverUploaded")
        }`}
      </Typography>
    </div>
  );
};
